import { render, staticRenderFns } from "./StatusMandatoNew.vue?vue&type=template&id=3802ba08&scoped=true&"
import script from "./StatusMandatoNew.vue?vue&type=script&lang=js&"
export * from "./StatusMandatoNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3802ba08",
  null
  
)

export default component.exports